import { createContext, useContext } from "react";
import { type Api } from "src/types/Api";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ApiContext = createContext<Api>(null as any);

export const useApi = () => useContext(ApiContext);
